import {
  BarChartIcon,
  ClockIcon,
  CollectionIcon,
  DollarSignIcon,
  MapIcon,
  SmileIcon,
} from '../../icons';
import AirshipInfoCard from './AirshipInfoCard';

const defaultOwnerItems = [
  {
    icon: <CollectionIcon />,
    text: 'Standardizes how your technicians sell in the field.',
  },
  {
    icon: <MapIcon />,
    text: 'Turns best practices from your top performers into a guide for your low performers.',
  },
  {
    icon: <BarChartIcon />,
    text: 'Increases business performance, sales efficiency, and transparency.',
  },
];

const defaultTechnicianItems = [
  {
    icon: <ClockIcon />,
    text: 'Reduces the time and effort to create proposals on the spot.',
  },
  {
    icon: <SmileIcon />,
    text: 'Builds a greater trust with customers through beautiful proposal presentations.',
  },
  {
    icon: <DollarSignIcon />,
    text: 'Increases replacement ticket sizes by 20% or more*.',
  },
];

const AirshipMarketingInfoCard: React.FC = () => (
  <AirshipInfoCard
    ownerItems={defaultOwnerItems}
    technicianItems={defaultTechnicianItems}
  />
);

export default AirshipMarketingInfoCard;
